import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRecentPosts } from '../../../actions/postActions';
import Spinner from '../../common/Spinner/Spinner';
import Blog from './Blog';


export class BlogContainer extends Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
    fetching: PropTypes.bool.isRequired,
    getRecentPosts: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.getRecentPosts();
  }

  render() {
    const { posts, fetching } = this.props;

    if (fetching) {
      return (
        <div className="blog-wrapper">
          <section className="blog" id="blog">
            <Spinner style={{ marginTop: '100px', marginBottom: '100px' }} />
          </section>
        </div>
      );
    } else if (posts.length > 0) {
      return (
        <Blog posts={posts} />
      );
    } else {
      return (
        <div className="blog-wrapper">
          <section className="blog" id="blog">
            <h1 className="section__name text-center w-100">Blog</h1>
            <div className="blog-items">
              <h5 className="text-center">Hamarosan...</h5>
            </div>
          </section>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  posts: state.posts.recent,
  fetching: state.posts.fetching
});

const mapDispatchToProps = {
  getRecentPosts
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogContainer);



// WEBPACK FOOTER //
// ./src/components/Home/Blog/BlogContainer.js